/**
 * Sprint 165 — Si el servidor dice que el nombre se parece a uno que ya existe, se pregunta UNA vez
 * "¿es otro producto distinto?". Sí → se reintenta confirmándolo. No → no se crea nada y queda el
 * mensaje que dice cuál usar. (Lo de "es el mismo escrito distinto" o "está oculto" no se pregunta:
 * el servidor no lo crea y el mensaje dice dónde está.)
 */
export async function conConfirmacionDeNombre<R extends { ok: boolean; error?: string; codigo?: string }>(
  enviar: (confirmado: boolean) => Promise<R>,
): Promise<R> {
  const r = await enviar(false);
  if (r.ok || r.codigo !== 'NOMBRE_PARECIDO') return r;
  const esOtro = window.confirm(
    `${r.error ?? 'Ya tienes uno con un nombre muy parecido.'}\n\n` +
      '¿Es OTRO producto distinto?\n\nAceptar = sí, es otro: créalo.\nCancelar = no, es el mismo: no crear nada.',
  );
  return esOtro ? enviar(true) : r;
}
